
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'euroCurrency' })
export class EuroCurrencyPipe implements PipeTransform {
  constructor() {}
  transform(value) {
    if (value && !isNaN(value)) {
          return parseFloat(value).toFixed(2) + ' €';
      }
      return '0.00 €';
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/commons/euro-currency.pipe.ts